import type { AccountTheme } from '@/contexts/ThemeContext'

// Metadados dos temas para o seletor de Aparencia (Perfil). Os hex dos
// mini-swatches espelham hero/brand/accent de styles/account-themes.css —
// sao amostras estaticas de proposito: cada card mostra o SEU tema, nao o
// tema ativo (por isso nao usa var()).
export interface ThemeMeta {
  value: AccountTheme
  label: string
  tag: string
  preview: { hero: string; brand: string; accent: string }
}

export const THEME_METADATA: ThemeMeta[] = [
  {
    value: 'azul',
    label: 'Cobalto',
    tag: 'Padrão da plataforma',
    preview: { hero: '#070B18', brand: '#2B5BD7', accent: '#8AACFF' },
  },
  {
    value: 'manuscrito',
    label: 'Manuscrito',
    tag: 'Tinta e ouro',
    preview: { hero: '#0B0906', brand: '#17130B', accent: '#E8CD88' },
  },
  {
    value: 'arcano',
    label: 'Arcano',
    tag: 'Índigo e ouro',
    preview: { hero: '#0A0912', brand: '#4B3FA6', accent: '#B3A6F0' },
  },
  {
    value: 'sinal',
    label: 'Sinal',
    tag: 'Grafite e verde',
    preview: { hero: '#0B0E0C', brand: '#16955C', accent: '#54D19A' },
  },
]
